import { SelectedMode } from 'store/buildingStore'
import { AnnotationType } from 'types/building'

/**
 * Mapping of allowed annotation types for each toolbar placement/edit mode.
 *
 * - ANNOTATION ("注釈"): Allows all general annotations (Architecture, Fire, etc.) and MEMO.
 *   Excludes 1-click Tour media annotations (Image, Movie, Info).
 * - TOUR_ANNOTATION ("ツアー注釈作成"): Strictly allows Tour media annotations (Image, Movie, Info).
 * - TOUR_MEMO_ANNOTATION ("メモ"): Strictly allows Memo annotations.
 */
export const ALLOWED_ANNOTATION_TYPES_BY_MODE: Partial<
  Record<SelectedMode, AnnotationType[]>
> = {
  [SelectedMode.ANNOTATION]: [
    AnnotationType.ARCHITECTURE,
    AnnotationType.AIR_CONDITION,
    AnnotationType.ELECTRICITY,
    AnnotationType.FIRE,
    AnnotationType.FLOOD,
    AnnotationType.EARTHQUAKE,
    AnnotationType.VOLCANO,
    AnnotationType.TRADITION,
    AnnotationType.EQUIPMENT,
    AnnotationType.LIFE_LINE,
    AnnotationType.DOCUMENT,
    AnnotationType.MEMO
  ],
  [SelectedMode.TOUR_ANNOTATION]: [
    AnnotationType.IMAGE,
    AnnotationType.MOVIE,
    AnnotationType.INFO
  ],
  [SelectedMode.TOUR_MEMO_ANNOTATION]: [AnnotationType.MEMO]
}

export default ALLOWED_ANNOTATION_TYPES_BY_MODE
